import React from 'react'
import { BetInfo } from '@orbital/games-frontend-library'
import getBetInfo from './helper/betInfo'
import { Title } from './CustomReplyStyles'

const BetInfoWrapper = ({ data, title, currency, precision }: any) => {
  const { BET_INFO } = getBetInfo(data, precision, currency, title)
  return (
    <>
      {data.bet !== '0' && (
        <>
          <Title>{title}</Title>
          <BetInfo content={BET_INFO} />
        </>
      )}
    </>
  )
}

export default BetInfoWrapper
